var exports = {
  "AF": "RefPillOcticon__4hSAiM",
  "VT": "RefPillTruncate__sEwxkK",
  "wQ": "RefPillText__LXTvij",
};

module.exports = exports;
